/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {validateLightningDeposit} from '../api'

export const useMutationValidateLightningDeposit = createReactQueryMutationHook('validateLightningDeposit', validateLightningDeposit)
